module.exports = __webpack_public_path__ + "img/Pic_Services-3.ed0822b7.jpg";